module.exports = __webpack_public_path__ + "img/t5_success.28fae1cb.svg";